import { SkyNav } from "@/components/sections/sky/sky-nav";

/**
 * Nagłówek wszystkich podstron: to samo pływające menu co na stronie głównej.
 * `overSky` — strona zaczyna się od `SkyPageHero` (menu jest wtedy szklane na niebie).
 * `promoHref` pozwala skierować pasek „Migracja za 0 zł" np. do formularza na stronie.
 */
export function SiteHeader({ overSky, promoHref }: { overSky?: boolean; promoHref?: string } = {}) {
  return <SkyNav overSky={overSky} promoHref={promoHref} />;
}
